<template>
  <div class="formulario-resultado-cita">
    <titulo-seccion titulo="RESULTADO DE LA CITA"></titulo-seccion>
    <div class="container contenedor-resultado-cita container-agenda">
      <form @submit="validarResultadoCita">
        <div class="col-lg-12">
          <p class="parrafo-instrucciones parrafo-agenda mt-2">
            Especifica la consecuencia de la cita realizada con el prospecto
          </p>
        </div>
        <div class="inputs-agenda">
          <div class="col-12">
            <label class="label-formulario-solicitud label-agenda"
              >Respuesta</label
            >
          </div>
          <div class="col-lg-12 col-sm-12">
            <DropDown
              placeholder="Selecciona una respuesta *"
              :arreglo="this.catalogos.respuestas"
              llave="caminoId"
              valor="caminoId"
              texto="nombre"
              v-model="DatosRespuesta.RespuestaId"
              :requerido="true"
            ></DropDown>
          </div>
          <div class="inputs-cancela">
            <div
              class="form-group col-md-12"
              v-if="DatosRespuesta.RespuestaId == 6"
            >
              <DropDown
                placeholder="Selecciona el motivo del rechazo *"
                :arreglo="this.catalogos.motivosCancelacion"
                llave="motivoCancelacionId"
                valor="motivoCancelacionId"
                texto="motivo"
                v-model="motivoCancelacion"
                :requerido="true"
              ></DropDown>
            </div>
            <div
              class="form-group col-md-12"
              v-if="DatosRespuesta.RespuestaId == 6"
            >
              <textarea
                placeholder="Observaciones"
                class="form-control campo-basico"
                rows="3"
                v-model="resultado.Observaciones"
              ></textarea>
            </div>
          </div>
          <div class="form-group col-md-12 mt-4">
            <button
              v-if="loadingResultadoCita"
              disabled
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="white"
              ></v-progress-circular>
            </button>
            <button
              v-else
              type="submit"
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">

import axios from "axios";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import DropDown from "../components/DropDown.vue";
//Variables
var rutaControlador = "/api/Master/Cancelacion/ListarMotivosCancelacionCita";
var rutaCargarResultados = "/api/Master/Etapa/ObtenerCaminosDeEtapaRealizarCita";
var rutaGuardarResultadoCita = "/api/Master/Cita/GuardarResultadoCita";
export default {
  name: "ResultadoCita",
  components: {
    TituloSeccion,
    DropDown
  },
  data() {
    return {
      catalogos: {
        respuestas:[],
        motivosCancelacion: []
      },
      loadingResultadoCita: false,
      DatosRespuesta: {
        RespuestaId: null
      },
      motivoCancelacion:null,
      resultado:{
        CitaId:null,
        CaminoId:null,
        MotivoCancelacionId:null,
        Observaciones:null,
        ProspectoId: this.$store.getters.prospectoId
      },
      citaId:0,
      prospectoId: this.$store.getters.prospectoId
    };
  },
  methods: {
    validarResultadoCita: function(e) {
      e.preventDefault();
      if(parseInt(this.DatosRespuesta.RespuestaId) === 0){
        this.AlertaEmbajadores("Debe seleccionar una respuesta", true);
        return;
      }

      if(parseInt(this.DatosRespuesta.RespuestaId) === 6){
        if(parseInt(this.motivoCancelacion) === 0){
          this.AlertaEmbajadores("Debe seleccionar un motivo de cancelación", true);
          return;
        }

        if(this.esCadenaNulaOTodosEspaciosEnBlanco(this.resultado.Observaciones)){
          this.AlertaEmbajadores("Debe ingresar las observaciones", true);
          return;
        }

      }

      const resultado = {
        "CitaId":this.citaId,
        "CaminoId":this.DatosRespuesta.RespuestaId,
        "MotivoCancelacionId":this.motivoCancelacion,
        "Observaciones":this.resultado.Observaciones,
        "ProspectoId":this.prospectoId
      }

      this.guardarResultadoCita(resultado);

    },
    guardarResultadoCita: function(resultado) {
    this.loadingResultadoCita = true;
      axios.post(rutaGuardarResultadoCita, resultado)
        .then(resp => {
          this.loadingResultadoCita = false;
          if (resp.data.estado === 0) {
            switch (parseInt(resultado.CaminoId)) {
              case 5:
                this.$router.push({
                  name: "RegistroCita"
                });
                break;
              case 7:
                  this.AlertaEmbajadores("El prospecto ha sido enviado a integrar su expediente.", true);
                  this.$router.push({
                    name: "AdministracionDeProspectos"
                  });
                break;
              case 6:
                  this.AlertaEmbajadores("El prospecto ha sido cancelado.", true);
                  this.$router.push({
                    name: "AdministracionDeProspectos"
                  });
                break;
            }

          } else if (resp.data.estado === 2) {
            this.AlertaEmbajadores(resp.data.estado.mensaje, true);
          }
        })
        .catch(e => {
          this.loadingResultadoCita = false;
          this.ManejarExcepcion(e);
        });

    },
    esCadenaNulaOTodosEspaciosEnBlanco: function(cadena) {
      return cadena === undefined || cadena === null
            || typeof cadena !== 'string'
            || cadena.match(/^ *$/) !== null;
    }
  },
  mounted() {
    axios
    .get(rutaCargarResultados)
    .then((resp) => {
      if (resp.data.estado === 0) {
        this.catalogos.respuestas = resp.data.data;
      } 
    })
    .catch(e => {
      this.ManejarExcepcion(e);
    });
  },
  watch: {
    "DatosRespuesta.RespuestaId": function (RespuestaId) {
      if(RespuestaId == 6){
        axios.get(rutaControlador)
             .then((resp) => {
                if (resp.data.estado === 0) {
                this.catalogos.motivosCancelacion = resp.data.data;
                } 
             })
            .catch((e) => {
             this.ManejarExcepcion(e);
            });
       }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.formulario-resultado-cita {
  flex-grow: 1;
}

.contenedor-resultado-cita {
  width: 75%;
}

@media (max-width: 512px) {
  .contenedor-resultado-cita {
    width: 100%;
  }
}

.btnRegistrarLlamada {
  background-color: #000000;
  border-radius: 8px;
  color: white;
  -webkit-box-shadow: 0px 8px 20px -6px rgba(85, 85, 85, 0.91);
  box-shadow: 0px 8px 20px -6px rgba(85, 85, 85, 0.91);
}
</style>
